import { render, staticRenderFns } from "./sendmsg.vue?vue&type=template&id=0803aeb8&scoped=true"
import script from "./sendmsg.vue?vue&type=script&lang=js"
export * from "./sendmsg.vue?vue&type=script&lang=js"
import style0 from "./sendmsg.vue?vue&type=style&index=0&id=0803aeb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0803aeb8",
  null
  
)

export default component.exports